export default __webpack_public_path__ + "static/media/app_logo_light.c529893b.svg";